// Generated by ReScript, PLEASE EDIT WITH CARE


var pickup_label = "Enter your Pickup Location";

var pickup_input_label = "Pickup Location";

var drop_input_label = "Drop Location";

var drop_label = "Enter your Drop Location";

var name_label = "Enter your name";

var mobile_label = "Enter your phone number";

var requirement_label = "What will you use Porter for?";

var requirement_label_modal = "I will be using Porter mainly for:";

var button_text = "Get an Estimate";

var form_error_invalid_number = "Invalid phone number";

var select_location_pickup_title = "Where is your Pickup?";

var select_location_dropoff_title = "Where is your Drop";

var current_location_label = "Use Current Location";

var locate_on_map_label = "Locate on Map";

var permission_denied_text = "Unable to fetch location";

var permission_denied_subtext = "Your location permission is off. Please provide access to your location in the browser for smooth deliveries.";

var permission_denied_action_button = "Search for location";

var location_denied_icon_url = "https://dom-content-vault-prod-cdn-assets.porter.in/location_denied_8ecd802f4e/location_denied_8ecd802f4e.svg";

var location_denied_icon_alt = "Location Permission Denied";

var confirm_pickup_action_label = "Confirm Pickup Location";

var confirm_drop_action_label = "Confirm Drop Location";

export {
  pickup_label ,
  pickup_input_label ,
  drop_input_label ,
  drop_label ,
  name_label ,
  mobile_label ,
  requirement_label ,
  requirement_label_modal ,
  button_text ,
  form_error_invalid_number ,
  select_location_pickup_title ,
  select_location_dropoff_title ,
  current_location_label ,
  locate_on_map_label ,
  permission_denied_text ,
  permission_denied_subtext ,
  permission_denied_action_button ,
  location_denied_icon_url ,
  location_denied_icon_alt ,
  confirm_pickup_action_label ,
  confirm_drop_action_label ,
}
/* No side effect */
